module.exports = __webpack_public_path__ + "img/icon_shouye_jiangquan.ed861df6.png";